/**
 * jQuery method bridges for BS5 components.
 *
 * BS4 inline scripts call $().modal('show'), $().tooltip(), etc.
 * BS5 registers its own jQuery plugins (via defineJQueryPlugin) but they
 * lack some BS4-specific methods (e.g., getTipElement for popovers).
 *
 * This file MUST be imported AFTER Bootstrap 5 (template.js) so that our
 * overrides take effect after BS5's defineJQueryPlugin calls.
 *
 * IMPORTANT: Uses window.jQuery and window.bootstrap explicitly because
 * esbuild's IIFE bundling may not resolve bare `jQuery`/`bootstrap` to
 * the window globals inside nested IIFEs.
 *
 * Remove after all inline scripts are migrated to native BS5 API.
 */
(function bridgeJQueryMethods() {
    var _jQuery = window.jQuery;
    var _bootstrap = window.bootstrap;
    if (!_jQuery || !_bootstrap) return;

    var $ = _jQuery;

    // $.fn.popover — enhanced bridge for bootstrap-colorpicker compatibility
    // MUST always override: BS5 creates its own $.fn.popover but it lacks
    // getTipElement() which bootstrap-colorpicker v3 needs.
    var _origPopover = $.fn.popover;
    $.fn.popover = function (optionsOrAction) {
        // getTipElement returns a jQuery-wrapped tip element (BS4 API)
        if (optionsOrAction === 'getTipElement') {
            var instance = _bootstrap.Popover.getInstance(this[0]);
            if (instance) {
                // Force tip creation if not yet created
                if (!instance.tip) {
                    instance.show();
                    instance.hide();
                }
                var tipEl = instance.tip;
                if (tipEl) {
                    // Store compat object so .data('bs.popover').tip works
                    $(tipEl).data('bs.popover', { tip: tipEl });
                    return $(tipEl);
                }
            }
            return $();
        }

        // For construction with options, handle BS4→BS5 differences
        if (typeof optionsOrAction === 'object') {
            var opts = Object.assign({}, optionsOrAction);

            // BS4 allowed jQuery objects as content; BS5 needs DOM element
            if (opts.content && opts.content instanceof $ && opts.content[0]) {
                opts.content = opts.content[0];
            }

            // BS5 requires sanitize=false for HTML content with DOM elements
            if (opts.html) {
                opts.sanitize = false;
            }

            return _origPopover.call(this, opts);
        }

        // Delegate all other calls to BS5's native $.fn.popover
        return _origPopover.call(this, optionsOrAction);
    };
})();
